import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { base44 } from '@/api/base44Client';
import { pagesConfig } from '@/pages.config';
import { getDeviceType } from '@/lib/deviceType';

const getSessionId = () => {
    let sessionId = sessionStorage.getItem('baselmitkindern_session');
    if (!sessionId) {
        sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        sessionStorage.setItem('baselmitkindern_session', sessionId);
    }
    return sessionId;
};

export default function NavigationTracker() {
    const location = useLocation();
    const { isAuthenticated } = useAuth();
    const { Pages, mainPage } = pagesConfig;
    const mainPageKey = mainPage ?? Object.keys(Pages)[0];

    // Track page views in Analytics (all visitors, every navigation)
    useEffect(() => {
        base44.entities.Analytics.create({
            event_type: 'page_view',
            session_id: getSessionId(),
            device_type: getDeviceType(),
            page_url: window.location.href,
            referrer: document.referrer,
        }).catch(() => {});
    }, [location]);

    // Log user activity for platform-level analytics (authenticated users only)
    useEffect(() => {
        const pathname = location.pathname;
        let pageName;

        if (pathname === '/' || pathname === '') {
            pageName = mainPageKey;
        } else {
            const pathSegment = pathname.replace(/^\//, '').split('/')[0];
            const pageKeys = Object.keys(Pages);
            const matchedKey = pageKeys.find(
                key => key.toLowerCase() === pathSegment.toLowerCase()
            );
            pageName = matchedKey || null;
        }

        if (isAuthenticated && pageName) {
            base44.appLogs.logUserInApp(pageName).catch(() => {});
        }
    }, [location, isAuthenticated, Pages, mainPageKey]);

    return null;
}